import React from 'react';

import { TFunction } from '@lyearn/i18n';

import { ContextualGroupsConfigType } from '../../types';
import RestrictedVisibilitySettingsGroupsTab from './components/RestrictedVisibilitySettingsGroupsTab';
import RestrictedVisibilitySettingsUsersTab from './components/RestrictedVisibilitySettingsUsersTab';
import { ModalTabsId, ModalTabsType } from './types';

export const getUsersTab: (props: { t: TFunction }) => ModalTabsType = ({ t }) => ({
  label: t('Group:Modal.Users'),
  value: ModalTabsId.USERS,
  renderer: ({ value, onChange }) => (
    <RestrictedVisibilitySettingsUsersTab value={value} onChange={onChange} />
  ),
});

export const getGroupsTab: (props: {
  t: TFunction;
  contextualGroupsConfig?: ContextualGroupsConfigType;
  allowCsvImport?: boolean;
}) => ModalTabsType = ({ t, contextualGroupsConfig, allowCsvImport }) => ({
  label: t('Group:Modal.Groups'),
  value: ModalTabsId.GROUPS,
  renderer: ({ value, onChange }) => (
    <RestrictedVisibilitySettingsGroupsTab
      allowCsvImport={allowCsvImport}
      contextualGroupsConfig={contextualGroupsConfig}
      value={value}
      onChange={onChange}
    />
  ),
});
